
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.cf3dc289.svg#" + id;
};
          